import { AbstractDiff } from '../../abstracts/AbstractDiff.js';

export class ColumnDiff extends AbstractDiff {}